export const materialTypesReceived = matTypes => ({
    type: 'MATERIAL_TYPES_RECEIVED',
    payload: matTypes
});
